import { useGoalResultsQuery } from '../../../__generated__/graphql';
import { InlineGoalObjective } from '../../../components/EmployeeFeedbackQuestionnaire/InlineGoalQuestion';

type UseInlineGoalsParams = {
  employeeId: string;
  objectiveTimePeriodId: string;
  skip?: boolean;
};

export const useInlineGoals = ({
  employeeId,
  objectiveTimePeriodId,
  skip = false,
}: UseInlineGoalsParams) => {
  const { data, loading, error } = useGoalResultsQuery({
    variables: {
      filter: {
        employeeId,
        periodId: objectiveTimePeriodId,
        categoryId: null,
        goalType: null,
        locationId: null,
        tagId: null,
        isRoot: true,
        approvalStatus: null,
      },
    },
    fetchPolicy: 'cache-and-network',
    skip,
  });

  const objectives = [...(data?.manager.employeesObjectives ?? [])]
    .filter(
      (o): o is InlineGoalObjective => o.__typename === 'EmployeeObjective',
    )
    .sort((a, b) => {
      const weightA = a.flair__Final_Weight__c ?? 0;
      const weightB = b.flair__Final_Weight__c ?? 0;
      return weightB - weightA;
    });

  return { objectives, loading, error };
};
